module.exports = __webpack_public_path__ + "static/journal-Circle.b543e26e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/journal-Circle.jpg
// module id = 351
// module chunks = 35783957827783